import React from 'react';
import * as S from './price-lock-tag.styles';

const PriceLockTag = ({ details, actionHandler, isFFModal = false }) => {
  const { t: priceLockText = '', bg: priceLockBg, i } = details || {};
  return (
    <S.FarelockBtn
      rndTRip={isFFModal}
      className="dF justifyCenter alignItemsCenter"
      onClick={actionHandler}
      bgColor={priceLockBg}
    >
      <span className="btnText">
        <img src={i?.lock} width="11" height="12" />
        <span className="marginL5 lh1">{priceLockText}</span>
      </span>
    </S.FarelockBtn>
  );
};

export default PriceLockTag;
